import { ObjectSchema, object } from 'libs/form';

export const applySchema = <T extends object>(
  check: boolean,
  schema: ObjectSchema<T>
) => (check ? schema : (object({}) as ObjectSchema<T>));
